import { weblinkFragment } from '../../graphql/fragments/weblinkFragment';
import { dynamicContentFragment } from '../../graphql/fragments/dynamicContentFragment';
import { graphql } from '../../graphql/graphql';

export const beforeYouBuyModalQuery = graphql(
  `
    query BeforeYouBuyModal($propertyId: String!, $toggleBYBLegalDisclaimers: Boolean = false) {
      beforeYouBuyV2(propertyId: $propertyId) {
        propertyPageModal {
          ...PropertyPage_BeforeYouBuy_Modal
        }
      }
    }

    fragment PropertyPage_BeforeYouBuy_Modal on PropertyPage_BeforeYouBuy_Modal {
      title
      propertyAddress
      priceBlock {
        priceTitle @skip(if: $toggleBYBLegalDisclaimers)
        priceTitleV2 @include(if: $toggleBYBLegalDisclaimers)
        price
        fullCost
        disclaimer
        disclaimerV2 @skip(if: $toggleBYBLegalDisclaimers) {
          ...DynamicContent
        }
        disclaimerV3 @include(if: $toggleBYBLegalDisclaimers) {
          ...DynamicContent
        }
      }
      eta @skip(if: $toggleBYBLegalDisclaimers)
      etaV2 @include(if: $toggleBYBLegalDisclaimers)
      featureTitle
      featureList @skip(if: $toggleBYBLegalDisclaimers)
      featureListV2 @include(if: $toggleBYBLegalDisclaimers) {
        ...DynamicContent
      }
      beforeYouBuyLink {
        ...WebLink
      }
    }
  `,
  [weblinkFragment, dynamicContentFragment],
);
